<template>
  <div>
    <c-row>
      <c-col sm="6" lg="3">
        <c-widget-progress footer="Lorem ipsum dolor sit amet enim.">
          <div class="h4 m-0">89.9%</div>
          <div class="card-header-actions">
            <a
              href="https://coreui.io/vue/docs/components/widgets"
              class="card-header-action position-absolute"
              style="right:5px; top:5px"
              rel="noreferrer noopener"
              target="_blank"
            >
              <small class="text-muted">docs</small>
            </a>
          </div>
          <div>Lorem ipsum...</div>
          <c-progress color="gradient-success" :value="25" class="progress-xs my-3 mb-0" />
        </c-widget-progress>
      </c-col>
      <c-col sm="6" lg="3">
        <c-widget-progress
          header="12.124"
          text="Lorem ipsum..."
          footer="Lorem ipsum dolor sit amet enim."
          color="gradient-info"
          :value="25"
        />
      </c-col>
      <c-col sm="6" lg="3">
        <c-widget-progress
          header="$98.111,00"
          text="Lorem ipsum..."
          footer="Lorem ipsum dolor sit amet enim."
          color="gradient-warning"
          :value="25"
        />
      </c-col>
      <c-col sm="6" lg="3">
        <c-widget-progress
          header="2 TB"
          text="Lorem ipsum..."
          footer="Lorem ipsum dolor sit amet enim."
          color="gradient-danger"
          :value="25"
        />
      </c-col>
    </c-row>
    <c-row>
      <c-col sm="6" lg="3">
        <c-widget-progress
          header="89.9%"
          text="Lorem ipsum..."
          footer="Lorem ipsum dolor sit amet enim."
          color="gradient-success"
          inverse
          :value="25"
        />
      </c-col>
      <c-col sm="6" lg="3">
        <c-widget-progress
          header="12.124"
          text="Lorem ipsum..."
          footer="Lorem ipsum dolor sit amet enim."
          color="gradient-info"
          inverse
          :value="25"
        />
      </c-col>
      <c-col sm="6" lg="3">
        <c-widget-progress
          header="$98.111,00"
          text="Lorem ipsum..."
          footer="Lorem ipsum dolor sit amet enim."
          color="gradient-warning"
          inverse
          :value="25"
        />
      </c-col>
      <c-col sm="6" lg="3">
        <c-widget-progress
          header="2 TB"
          text="Lorem ipsum..."
          footer="Lorem ipsum dolor sit amet enim."
          color="gradient-danger"
          inverse
          :value="25"
        />
      </c-col>
    </c-row>
    <c-row>
      <c-col col="12" sm="6" lg="3">
        <c-widget-icon header="$1.999,50" text="Income" color="gradient-primary">
          <c-icon name="cil-settings" width="24" />
        </c-widget-icon>
      </c-col>
      <c-col col="12" sm="6" lg="3">
        <c-widget-icon header="$1.999,50" text="Income" color="gradient-info">
          <c-icon name="cil-laptop" width="24" />
        </c-widget-icon>
      </c-col>
      <c-col col="12" sm="6" lg="3">
        <c-widget-icon header="$1.999,50" text="Income" color="gradient-warning">
          <c-icon name="cil-moon" width="24" />
        </c-widget-icon>
      </c-col>
      <c-col col="12" sm="6" lg="3">
        <c-widget-icon header="$1.999,50" text="Income" color="gradient-danger">
          <c-icon name="cil-bell" width="24" />
        </c-widget-icon>
      </c-col>
    </c-row>
    <c-row>
      <c-col col="12" sm="6" lg="3">
        <c-widget-icon header="$1.999,50" text="Income" color="gradient-primary" :icon-padding="false">
          <c-icon name="cil-settings" width="24" />
        </c-widget-icon>
      </c-col>
      <c-col col="12" sm="6" lg="3">
        <c-widget-icon header="$1.999,50" text="Income" color="gradient-info" :icon-padding="false">
          <c-icon name="cil-laptop" width="24" />
        </c-widget-icon>
      </c-col>
      <c-col col="12" sm="6" lg="3">
        <c-widget-icon header="$1.999,50" text="Income" color="gradient-warning" :icon-padding="false">
          <c-icon name="cil-moon" width="24" />
        </c-widget-icon>
      </c-col>
      <c-col col="12" sm="6" lg="3">
        <c-widget-icon header="$1.999,50" text="Income" color="gradient-danger" :icon-padding="false">
          <c-icon name="cil-bell" width="24" />
        </c-widget-icon>
      </c-col>
    </c-row>
    <c-row>
      <c-col col="12" sm="6" lg="4">
        <c-widget-icon header="$1.999,50" text="Income" color="gradient-primary" :icon-padding="false">
          <c-icon name="cil-settings" class="mx-5 " width="24" />
        </c-widget-icon>
      </c-col>
      <c-col col="12" sm="6" lg="4">
        <c-widget-icon header="$1.999,50" text="Income" color="gradient-info" :icon-padding="false">
          <c-icon name="cil-laptop" class="mx-5 " width="24" />
        </c-widget-icon>
      </c-col>
      <c-col col="12" sm="6" lg="4">
        <c-widget-icon header="$1.999,50" text="Income" color="gradient-warning" :icon-padding="false">
          <c-icon name="cil-moon" class="mx-5 " width="24" />
          <template #footer>
            <c-card-footer class="card-footer px-3 py-2">
              <c-link class="font-weight-bold font-xs btn-block text-muted" href="https://coreui.io/">
                View more
                <c-icon name="cil-arrowRight" class="float-right" width="16" />
              </c-link>
            </c-card-footer>
          </template>
        </c-widget-icon>
      </c-col>
    </c-row>
    <!-- <CRow>
      <CCol col="12" sm="6" lg="4">
        <CWidgetIcon
          header="$1.999,50"
          text="Income"
          color="gradient-primary"
          :icon-padding="false"
          link="#"
        >
          <CIcon name="cil-settings" class="mx-5 " width="24"/>
        </CWidgetIcon>
      </CCol>
      <CCol col="12" sm="6" lg="4">
        <CWidgetIcon
          header="$1.999,50"
          text="Income"
          color="gradient-info"
          :icon-padding="false"
          link="#"
        >
          <CIcon name="cil-laptop" class="mx-5 " width="24"/>
        </CWidgetIcon>
      </CCol>
      <CCol col="12" sm="6" lg="4">
        <CWidgetIcon
          header="$1.999,50"
          text="Income"
          color="gradient-warning"
          :icon-padding="false"
          link="#"
        >
          <CIcon name="cil-moon" class="mx-5" width="24"/>
        </CWidgetIcon>
      </CCol>
    </CRow> -->
    <widgets-brand no-charts />
    <widgets-brand />
    <c-card-group class="mb-4">
      <c-widget-progress-icon header="87.500" text="Visitors" color="gradient-info">
        <c-icon name="cil-people" height="36" />
      </c-widget-progress-icon>
      <c-widget-progress-icon header="385" text="New Clients" color="gradient-success">
        <c-icon name="cil-userFollow" height="36" />
      </c-widget-progress-icon>
      <c-widget-progress-icon header="1238" text="Products sold" color="gradient-warning">
        <c-icon name="cil-basket" height="36" />
      </c-widget-progress-icon>
      <c-widget-progress-icon header="28%" text="Returning Visitors">
        <c-icon name="cil-chartPie" height="36" />
      </c-widget-progress-icon>
      <c-widget-progress-icon header="5:34:11" text="Avg. Time" color="gradient-danger">
        <c-icon name="cil-speedometer" height="36" />
      </c-widget-progress-icon>
    </c-card-group>
    <c-card-group class="mb-4">
      <c-widget-progress-icon header="87.500" text="Visitors" color="gradient-info" inverse>
        <c-icon name="cil-people" height="36" />
      </c-widget-progress-icon>
      <c-widget-progress-icon header="385" text="New Clients" color="gradient-success" inverse>
        <c-icon name="cil-userFollow" height="36" />
      </c-widget-progress-icon>
      <c-widget-progress-icon header="1238" text="Products sold" color="gradient-warning" inverse>
        <c-icon name="cil-basket" height="36" />
      </c-widget-progress-icon>
      <c-widget-progress-icon header="28%" text="Returning Visitors" color="gradient-primary" inverse>
        <c-icon name="cil-chartPie" height="36" />
      </c-widget-progress-icon>
      <c-widget-progress-icon header="5:34:11" text="Avg. Time" color="gradient-danger" inverse>
        <c-icon name="cil-speedometer" height="36" />
      </c-widget-progress-icon>
    </c-card-group>
    <c-row>
      <c-col sm="6" md="2">
        <c-widget-progress-icon header="87.500" text="Visitors" color="gradient-info">
          <c-icon name="cil-people" height="36" />
        </c-widget-progress-icon>
      </c-col>
      <c-col sm="6" md="2">
        <c-widget-progress-icon header="385" text="New Clients" color="gradient-success">
          <c-icon name="cil-userFollow" height="36" />
        </c-widget-progress-icon>
      </c-col>
      <c-col sm="6" md="2">
        <c-widget-progress-icon header="1238" text="Products sold" color="gradient-warning">
          <c-icon name="cil-basket" height="36" />
        </c-widget-progress-icon>
      </c-col>
      <c-col sm="6" md="2">
        <c-widget-progress-icon header="28%" text="Returning Visitors" color="gradient-primary">
          <c-icon name="cil-chartPie" height="36" />
        </c-widget-progress-icon>
      </c-col>
      <c-col sm="6" md="2">
        <c-widget-progress-icon header="5:34:11" text="Avg. Time" color="gradient-danger">
          <c-icon name="cil-speedometer" height="36" />
        </c-widget-progress-icon>
      </c-col>
      <c-col sm="6" md="2">
        <c-widget-progress-icon header="972" text="comments" color="gradient-info">
          <c-icon name="cil-speech" height="36" />
        </c-widget-progress-icon>
      </c-col>
    </c-row>
    <c-row>
      <c-col sm="6" md="2">
        <c-widget-progress-icon header="87.500" text="Visitors" color="gradient-info" inverse>
          <c-icon name="cil-people" height="36" />
        </c-widget-progress-icon>
      </c-col>
      <c-col sm="6" md="2">
        <c-widget-progress-icon header="385" text="New Clients" color="gradient-success" inverse>
          <c-icon name="cil-userFollow" height="36" />
        </c-widget-progress-icon>
      </c-col>
      <c-col sm="6" md="2">
        <c-widget-progress-icon header="1238" text="Products sold" color="gradient-warning" inverse>
          <c-icon name="cil-basket" height="36" />
        </c-widget-progress-icon>
      </c-col>
      <c-col sm="6" md="2">
        <c-widget-progress-icon header="28%" text="Returning Visitors" color="gradient-primary" inverse>
          <c-icon name="cil-chartPie" height="36" />
        </c-widget-progress-icon>
      </c-col>
      <c-col sm="6" md="2">
        <c-widget-progress-icon header="5:34:11" text="Avg. Time" color="gradient-danger" inverse>
          <c-icon name="cil-speedometer" height="36" />
        </c-widget-progress-icon>
      </c-col>
      <c-col sm="6" md="2">
        <c-widget-progress-icon header="972" text="comments" color="gradient-info" inverse>
          <c-icon name="cil-speech" height="36" />
        </c-widget-progress-icon>
      </c-col>
    </c-row>
    <widgets-dropdown />
    <c-row>
      <c-col sm="4" lg="2">
        <c-widget-simple header="title" text="1,123">
          <c-chart-line-simple style="height:40px" border-color="danger" />
        </c-widget-simple>
      </c-col>
      <c-col sm="4" lg="2">
        <c-widget-simple header="title" text="1,123">
          <c-chart-line-simple style="height:40px" border-color="primary" />
        </c-widget-simple>
      </c-col>
      <c-col sm="4" lg="2">
        <c-widget-simple header="title" text="1,123">
          <c-chart-line-simple style="height:40px" border-color="success" />
        </c-widget-simple>
      </c-col>
      <c-col sm="4" lg="2">
        <c-widget-simple header="title" text="1,123">
          <c-chart-bar-simple style="height:40px" background-color="danger" />
        </c-widget-simple>
      </c-col>
      <c-col sm="4" lg="2">
        <c-widget-simple header="title" text="1,123">
          <c-chart-bar-simple style="height:40px" background-color="primary" />
        </c-widget-simple>
      </c-col>
      <c-col sm="4" lg="2">
        <c-widget-simple header="title" text="1,123">
          <c-chart-bar-simple style="height:40px" background-color="success" />
        </c-widget-simple>
      </c-col>
    </c-row>
  </div>
</template>

<script>
import WidgetsBrand from './WidgetsBrand';
import WidgetsDropdown from './WidgetsDropdown';
import { CChartLineSimple, CChartBarSimple } from '../charts/index.js';

export default {
  name: 'Widgets',
  components: {
    CChartLineSimple,
    CChartBarSimple,
    WidgetsBrand,
    WidgetsDropdown,
  },
};
</script>
